<template>
  <div>
    <Drawer
        title="首页人员分配"
        v-model="isMemberConfig"
        width="540"
        :mask-closable="false"
        :styles="styles"
        class-name='scmcc-member-Config'
        @on-close="closeMemberConfig"
    >
      <div class="fromitem">
        <span class="label-class">当前首页</span>
        <span class="label-class1">{{pageName}}</span>
      </div>
      <div class="fromitem">
        <div class="label-class">分配人员</div>
        <treeselect v-model="treeValue" placeholder="" :multiple="true" :options="options" value-consists-of="LEAF_PRIORITY"/>
      </div>
      <div class="demo-drawer-footer">
        <Button style="margin-right: 8px" @click="closeMemberConfig()">取消</Button>
        <Button type="primary" @click="submit">保存</Button>
      </div>
    </Drawer>    
  </div>
</template>
<script>
  import Treeselect from '@riophae/vue-treeselect'
  export default {
    components: {Treeselect},
    data () {
      return {
        isdefault: false,
        treeValue: [],
        sbumitData: '',
        pageName: '',
        pageId: '',
        options: [],
        isMemberConfig: false,
        styles: {
            height: 'calc(100% - 55px)',
            overflow: 'auto',
            paddingBottom: '53px',
            position: 'static'
        },  
      }
    },
    mounted() {
      this.queryMember();
    },
    methods:{
      //查询人员树
      queryMember() {
        let param = JSON.parse(localStorage.user).info.tenantId;
        this.$http.get('/sctm/organizations/getOrgAndUserTree',{params: {tenantId:param}}).then(res =>{
          if(res.data.returnCode == 0){
            this.options = res.data.beans;
          } else{
            this.$Message.error("部门树查询失败！");
          }
        })
      },
      selectMember() {
        //调接口拿到选中人员
        this.$http.get('/sctm/getUserIdsByIndexId',{params: {indexId:this.pageId}}).then(res =>{
          if(res.data.returnCode == 0){
            let data = JSON.parse(res.data.bean)
            if(data.length == 0){
              this.isdefault = true;
            }
            this.treeValue = data.map(_ => _.userId);
          } else{
            this.$Message.error("分配人员查询失败！");
          }
        })
      },
      openMemberConfig(data1,data2) {
        this.pageName = data1;
        this.pageId = data2;
        this.selectMember();
        this.isMemberConfig = true;
      },
      closeMemberConfig() {
        this.isMemberConfig = false;
      },
      submit() {
        //保存提交数据
        let param;
        if(this.isdefault && (this.treeValue.length == 0)){
          param = [{indexId: this.pageId + '' , userId: 'default'}];
        } else if (!this.isdefault && (this.treeValue.length == 0)){
          param = [{indexId: this.pageId + '' , userId: 'nobody'}];
        } else {
          param = this.treeValue.map(_ =>({ indexId: this.pageId + '' , userId: _ }))
        }
        let data = {
          jsonStringOrigin: param
        }
        this.$http.post('/sctm/updateCustomIndexUser', data).then(res => {
          if(res.data.returnCode == 0){
            this.$Message.success(res.data.bean.returnMessage);
            this.$parent.queryFirstPageList();
            this.closeMemberConfig()
          } else{
            this.$Message.error("新增分配人员失败！");
          }
        })
      }
    }
  }
</script>
<style lang="less">
.scmcc-member-Config{
  .vue-treeselect__value-container:focus {
    color: #04cbd8;
  }
  .ivu-drawer-header {
      padding: 36px;
  }
  .demo-drawer-footer{
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: right;
    background: #fff;
  }
  .vue-treeselect {
    width: 400px;
    &__multi-value {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    }
  }
  .ivu-drawer-header-inner {
    font-size: 18px;  
  }
  .ivu-drawer-body{
    padding: 36px;
  }
  .vue-treeselect:not(.vue-treeselect--disabled):not(.vue-treeselect--focused) * {
    vertical-align: middle;
  }
  .fromitem{
    display:flex;
    margin-bottom: 24px;
    .label-class1{
      color: #33344a;
      font-size: 14px;
      line-height: 36px;
    }
    .label-class{
      .label-class1;
      flex: 0 0 80px;
      text-align: right;
      padding-right: 16px;
    }
    .value-class{
      flex: 1;
    }
  }
} 
</style>